import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const EditMessage = ({ isOpen, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onClose();
  };
  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-4 pb-6 pt-3 sm:px-6">
                <div className="flex justify-between items-center mb-4">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    Edit Message
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="text-[#1C2024] p-1.5 rounded-full"
                  >
                    <IoMdClose className="text-xl sm:text-2xl" />
                  </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm sm:text-base font-semibold mb-1.5">
                      Custom Message
                    </label>
                    <textarea
                      type="text"
                      name="customMessage"
                      className="w-full rounded-xl border border-gray-300 py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow"
                      placeholder="Enter Custom Message"
                      rows={3}
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 pt-2">
                    <button
                      type="button"
                      onClick={onClose}
                      className="w-full rounded-md border font-semibold border-[#F04438] bg-white px-4 py-2 text-sm text-[#F04438] hover:bg-red-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="w-full rounded-md border font-semibold border-transparent bg-[#284184] px-4 py-2 text-sm text-white hover:bg-[#1f3266] transition-colors"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default EditMessage;
